import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Button } from "src/@/components/ui/button";
import useAuth from 'src/hooks/useAuth';
import config from 'src/config';
import actionGoogleLogout from 'src/actions/integrations.lais/actionGoogleLogout';
import Iconify from 'src/components/Iconify';
import { TermosPrivacidade } from './TermosPrivacidade';

const GoogleLogin = ({ clienteId, onLoginSuccess, data, onCallback, red }) => {
    const { t } = useTranslation('settings');
    const { cliente } = useAuth();
    const [user, setUser] = useState(null);
    const [aceitouTermos, setAceitouTermos] = useState(false);
    const [modalAberto, setModalAberto] = useState(false);
    console.log('data', data)

    const handleLogin = async () => {
        if (!aceitouTermos) {
            alert(t('integrations.google.login.acceptTermsAlert', 'Por favor, aceite os termos de privacidade primeiro'));
            return;
        }

        const urlAuth = `${config?.dev ? config?.api_prod_integrations : config?.api_prod_integrations}/api/google/auth/${cliente._id}/redirect-url`;
        console.log('urlAuth', urlAuth)
        window.location.href = urlAuth;
    };

    // Detecta o callback com os dados do usuário
    const handleCallback = () => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const loged = params.get('loged') === 'true';

        if (loged && email) {
            setUser({ email });
            if (onLoginSuccess) {
                onLoginSuccess({ email });
            }
        }
    };

    

    React.useEffect(() => {
        // Verifica se o callback foi chamado
        handleCallback();
    }, []);

    const handleLogout = async () => {
        setUser(null);
        await actionGoogleLogout(clienteId, data?.email);
        onCallback()
    };

    const ModalTermos = () => (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-900">{t('integrations.google.login.termsModal.title', 'Termos de Privacidade')}</h2>
                    <button
                        onClick={() => setModalAberto(false)}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <Iconify icon="mdi:close" className="w-6 h-6" />
                    </button>
                </div>

                <TermosPrivacidade />

                <div className="mt-6 flex justify-end gap-4">
                    <Button
                        onClick={() => setModalAberto(false)}
                        className="bg-gray-100 hover:bg-gray-200 text-gray-700"
                    >
                        {t('buttons.close', { ns: 'common' })}
                    </Button>
                    <Button
                        onClick={() => {
                            setAceitouTermos(true);
                            setModalAberto(false);
                        }}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        {t('integrations.google.login.termsModal.acceptButton', 'Aceitar Termos')}
                    </Button>
                </div>
            </div>
        </div>
    );

    return (
        <GoogleOAuthProvider clientId={clienteId}>
            <div className="flex flex-col mt-4">
                {!data?.logged ? (
                    <div className="flex flex-col gap-2">
                        <p className="text-xs text-gray-700">
                            {t('integrations.google.login.description', 'Entre com sua conta Google para vincular o calendário')}
                        </p>
                        <div className="flex items-center gap-2 mb-2">
                            <input
                                type="checkbox"
                                id="termos"
                                checked={aceitouTermos}
                                onChange={(e) => setAceitouTermos(e.target.checked)}
                            />
                            <label htmlFor="termos" className="text-xs text-gray-700">
                                <Trans
                                    t={t}
                                    i18nKey="integrations.google.login.termsCheckboxLabel"
                                    defaults="Li e aceito os <termsLink>termos de privacidade</termsLink>"
                                    components={{
                                        termsLink: (
                                            <button
                                                onClick={() => setModalAberto(true)}
                                                className="text-blue-600 hover:underline"
                                                type="button"
                                            />
                                        ),
                                    }}
                                />
                            </label>
                        </div>
                        <Button
                            onClick={handleLogin}
                            className={`flex items-center justify-center gap-2 w-[240px] h-10 rounded border border-gray-300 ${!aceitouTermos ? 'bg-gray-100 cursor-not-allowed' : 'bg-white hover:bg-gray-50'} text-gray-700 font-medium shadow-sm`}
                            disabled={!aceitouTermos}
                        >
                            <Iconify icon="logos:google-icon" className="w-5 h-5" />
                            <span>{t('integrations.google.login.connectButton', 'Entrar com Google')}</span>
                        </Button>
                    </div>
                ) : (
                    <div className="flex flex-col rounded p-4 border bg-slate-50">
                        <p className="text-xs text-gray-700">{t('integrations.google.login.connectedLabel', 'Conta Google configurada:')}</p>
                        <span className="font-bold text-gray-900">{data?.email}</span>
                        <Button
                            onClick={handleLogout}
                            className="mt-4 flex items-center justify-center gap-2 w-[240px] h-10 rounded border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 font-medium shadow-sm"
                        >
                            <Iconify icon="logos:google-icon" className="w-5 h-5" />
                            <span>{t('integrations.google.login.disconnectButton', 'Desvincular conta')}</span>
                        </Button>
                    </div>
                )}
            </div>

            {modalAberto && <ModalTermos />}
        </GoogleOAuthProvider>
    );
};

export default GoogleLogin;
